UpdateAppURLHelper = require '../../../shared/frontend/helpers/app_url'
PaginatedDealsBuilder = require './paginated_deals_builder'
DealsPaginationEvents = require '../pagination_events'

module.exports = DealsPaginationEventsHelper =
  updatePageByHref: (url, shouldScroll = true) ->
    updateURLAndFetch(url, shouldScroll)

  updateToPreviousPage: (shouldScroll = true) ->
    qs = Groupon.Utils.unparam()

    return unless qs.page > 1
    qs.page--
    delete qs.page if qs.page <= 1

    queryString = unless _.isEmpty(qs) then "?#{$.param(qs)}" else ""

    url = "#{window.location.pathname}#{queryString}"
    updateURLAndFetch(url, shouldScroll)

  updateToNextPage: (shouldScroll = true) ->
    qs = Groupon.Utils.unparam()

    if qs.page? then qs.page++ else qs.page = 2

    return if qs.page > Groupon.pagination.totalPages

    url = "#{window.location.pathname}?#{$.param(qs)}"
    updateURLAndFetch(url, shouldScroll)

  popStateHandler: (currentSearchPage) ->
    popStatePage = Groupon.Utils.unparam().page ? 1

    fetchAndRenderDeals() unless currentSearchPage is popStatePage

updateURLAndFetch = (url, shouldScroll) ->
  UpdateAppURLHelper(url, {pushState: true})
  $(document).scrollTop(0) if shouldScroll
  fetchAndRenderDeals()

fetchAndRenderDeals = ->
  paginatedBuilder = new PaginatedDealsBuilder

  # temporary workaround to circular dependency
  Groupon.browseApp.renderContent
    paginatedDealsBuilder: paginatedBuilder

  paginatedBuilder.on "fetchSuccess", (search) ->
    sendPaginationEvent(search)

sendPaginationEvent = (dealSearch) ->
  DealsPaginationEvents.trigger("newPage", dealSearch.page)
